"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultLayoutTranslationKeysWithNamespaces = void 0;
var _footer = require("@ori/footer");
var _languageSwitcher = require("@ori/language-switcher");
var _logoutConfirmDialog = require("@ori/logout-confirm-dialog");
var _notificationMenu = require("@ori/notification-menu");
var _personalMenu = require("@ori/personal-menu");
var _skipTo = require("@ori/skip-to");
var _topArea = require("@ori/top-area");
/**
 * Represents a collection of translation keys used in the DefaultLayout component.
 *
 * This object combines translation keys from various parts of the layout,
 * such as `top area`, `language switcher`, and `footer`.
 *
 * @remarks
 * The translation keys included in this object are essential for providing localized content
 * to users within the DefaultLayout component.
 */
const defaultLayoutTranslationKeysWithNamespaces = exports.defaultLayoutTranslationKeysWithNamespaces = {
  ..._topArea.defaultTranslationsWithNamespaces,
  ..._languageSwitcher.defaultTranslationsWithNamespaces,
  ..._footer.defaultTranslationsWithNamespaces,
  ..._personalMenu.defaultTranslationsWithNamespaces,
  ..._notificationMenu.defaultTranslationsWithNamespaces,
  ..._skipTo.defaultTranslationsWithNamespaces,
  ..._logoutConfirmDialog.defaultTranslationsWithNamespaces
};
